import http, { refreshSession, setAccessToken, setSessionLostHandler } from './http.js';
import useAuthStore from '../stores/authStore.js';
import { queryClient } from './queryClient.js';

function forgetServerState() {
  queryClient.clear();
}

export async function signup(payload) {
  const result = await http.post('/auth/signup', payload);
  useAuthStore.getState().setSession(result);
  return result;
}

export async function login(payload) {
  const result = await http.post('/auth/login', payload);
  forgetServerState();
  useAuthStore.getState().setSession(result);
  return result;
}

export async function logout() {
  try {
    await http.post('/auth/logout');
  } catch {
    // Graceful drop
  } finally {
    useAuthStore.getState().clearSession();
    forgetServerState();
  }
}

export const me = () => http.get('/auth/me');

export async function updateProfile(payload) {
  const { user } = await http.patch('/auth/me', payload);
  useAuthStore.getState().setUser(user);
  return user;
}

export async function changePassword(payload) {
  const result = await http.post('/auth/change-password', payload);
  useAuthStore.getState().setSession(result);
  return result;
}

export async function verifyEmail(token) {
  const result = await http.post('/auth/verify-email', { token });
  if (result?.user) {
    useAuthStore.getState().setUser(result.user);
  }
  return result;
}

export async function resendVerification(email) {
  return http.post('/auth/resend-verification', { email });
}

export async function forgotPassword(email) {
  return http.post('/auth/forgot-password', { email });
}

export async function resetPassword(token, password) {
  return http.post('/auth/reset-password', { token, password });
}

export async function bootstrapSession() {
  try {
    const session = await refreshSession();
    useAuthStore.getState().setSession(session);
    return session;
  } catch {
    setAccessToken(null);
    useAuthStore.getState().clearSession();
    return null;
  }
}

setSessionLostHandler(() => {
  useAuthStore.getState().clearSession();
  forgetServerState();
});

export default {
  signup,
  login,
  logout,
  me,
  updateProfile,
  changePassword,
  verifyEmail,
  resendVerification,
  forgotPassword,
  resetPassword,
  bootstrapSession,
};
